
import Vue from "vue";
// import $ from "jquery";
// import { eventBus, events } from "./eventBus";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { RenderablePlaylistEntry } from "../interfaces/playlist";
import { PlayerActions } from "../store/store.actions";
import { PlayerGetters } from "../store/store.getters";

@Component({})
export default class PlaylistSelection extends Vue {
  closed = true;
  didTogglePaused = false;
  @Action(PlayerActions.setCurrentIndex) setCurrentIndex!: (index: number) => void;
  @Action(PlayerActions.togglePaused) togglePaused!: () => void;
  @Getter(PlayerGetters.renderablePlaylist) playlist!: RenderablePlaylistEntry[];
  @Getter(PlayerGetters.paused) paused!: boolean;
  @Getter(PlayerGetters.currentIndex) currentIndex!: number;
  @Action(PlayerActions.setTriggered) setTriggered!: (triggered: boolean) => void;
  @Getter(PlayerGetters.playlistsHash) playlistsHash!: string;

  close() {
    this.closed = true;
  }

  triggerPlaylistItem(chunkIndex: number, itemIndex: number) {
    this.setTriggered(true);
    this.setCurrentIndex(chunkIndex * this.breakpointToChunkSize() + itemIndex);
  }

  getUrl(item: RenderablePlaylistEntry): string {
    if (item.contentItem.thumbnail_url) {
      return item.contentItem.thumbnail_url;
    }
    return item.contentItem.url;
  }

  breakpointToChunkSize(): number {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return 1;
      case "sm":
        return 1;
      case "md":
        return 2;
      case "lg":
        return 3;
      case "xl":
        return 4;
    }
  }

  selectionStyle(chunkIndex: number, itemIndex?: number) {
    return chunkIndex === this.carouselPage && itemIndex === this.currentIndex % this.breakpointToChunkSize()
      ? {
          boxShadow: "rgba(139, 195, 74,0.9) 0 0 0 3px",
          borderRadius: "1px",
          backgroundColor: "rgba(139, 195, 74,0.9)",
        }
      : {};
  }

  get chunkedPlaylist(): RenderablePlaylistEntry[][] {
    if (this.playlist.length > 0) {
      return this.playlist
        .map((val, index) => {
          return { ...val, index };
        })
        .chunk(this.breakpointToChunkSize());
    }
    return [];
  }

  get carouselPage() {
    return Math.floor(this.currentIndex / this.breakpointToChunkSize());
  }
  get rippleOptions() {
    return { center: true, class: "primary--text" };
  }
  get dialogWidth() {
    const portrait = window.matchMedia("(orientation: portrait)").matches;
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
      case "sm":
        return portrait ? "100%" : "65%";
    }
    return "80%";
  }
  get carouselHeight() {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
        return 184;
      case "sm":
        return 324;
      case "md":
        return 230;
      case "lg":
        return 300;
      case "xl":
        return 400;
      default:
        return 400;
    }
  }

  @Watch("paused", { deep: true })
  pausedWatcher() {
    this.didTogglePaused = true;
    this.closed = !this.paused;
  }
}
